// @ts-nocheck
import { colors} from '@/theme/index';
import {createTheme} from "@mui/material";

export const themeOptions = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: `${colors.bluePrimary}`,
    },
    secondary: {
      main: `${colors.labelGrey}`,
    },
    error: {
      main: `${colors.warningRed}`,
    },
  },
});
